import { render, staticRenderFns } from "./womenCarnival.vue?vue&type=template&id=64e28ed9&"
import script from "./womenCarnival.vue?vue&type=script&lang=js&"
export * from "./womenCarnival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports